module.exports = __webpack_public_path__ + "80216e9766f7c61e85c9be8e0ab5bdbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-no-problem.png
// module id = 2066
// module chunks = 4